export function normalizeLineEndings(str: string): string {
  // replace Windows line endings, CRLF (\r\n), or old Mac line endings, CR (\r),
  // with Unix line endings, LF (\n)
  return str.replace(/\r\n?/g, '\n');
}
